module.exports = __webpack_public_path__ + "img/vegetable-bok-choy-350x184.86b0d9fe.jpg";